import { createClient } from '@supabase/supabase-js';
import {
  appEnv,
  isLocalSurface,
  isQaSurface,
  isSupabaseConfigured,
  isVercelPreviewHost,
  supabaseKey,
  supabaseSchema,
  supabaseUrl,
} from '@/config/runtime';

export const isQaEnv = isQaSurface;
export const isVercelPreview = isVercelPreviewHost;
export const isLocalDev = isLocalSurface;

// Nota: el esquema CRM vive en `public` (el proyecto Supabase QA ya es el
// aislamiento). Ignoramos REACT_APP_SUPABASE_SCHEMA (quedó con un valor legacy
// 'conectacrmqa') para que Auth y las RPC (setup_new_user, etc.) resuelvan en public.
const effectiveSchema = supabaseSchema && supabaseSchema !== 'conectacrmqa' ? supabaseSchema : undefined;

export const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl!, supabaseKey!, {
      db: effectiveSchema ? { schema: effectiveSchema } : undefined,
    })
  : null;
